<template>
  <div class="coupon-overview-wrapper"
       v-if="couponOverview"
       :class="{ loading: loading, normal: !isPremium }">
      <div class="listing-title">
        <span class="title">總覽</span>
          <DateTimePicker
            class="pt-4 custom-datepicker"
            v-model="dateRange"
            has-range
            placeholder="選擇日期"
            :customShortcuts="couponOverviewShortcuts"
            style="position: relative;top:-30px;"
          ></DateTimePicker>
      </div>
      <div class="overview-wrapper">
        <div class="overview">
          <div class="left">
            <span class="quantity">
              {{ couponOverview.ufunCoupon }}
            </span>
            <span class="title">
              積分優惠券數目
            </span>
          </div>
          <div class="right">
            <img src="../../assets/img/ufuncoupon.png" />
          </div>
        </div>
        <div class="vl" v-if="isPremium"></div>
        <div class="overview" v-if="isPremium">
          <div class="left">
            <span class="quantity">
              {{ couponOverview.paidCoupon }}
            </span>
            <span class="title">
              付費優惠券數目
            </span>
          </div>
          <div class="right">
            <img src="../../assets/img/paidcoupon.png" />
          </div>
        </div>
        <div class="vl" v-if="isPremium"></div>
        <div class="overview" v-if="isPremium">
          <div class="left">
            <span class="quantity">
              {{ couponOverview.order }}
            </span>
            <span class="title">
              訂單數目
            </span>
          </div>
          <div class="right">
            <img src="../../assets/img/order.png" />
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {
} from 'bootstrap-vue';
import {
  getMonthStartDate,
  getMonthEndDate,
  addDays,
} from '@/helpers/date';

import DateTimePicker from '@/components/DateTimePicker.vue';

const now = new Date();
const nowYear = now.getFullYear();

export default {
  watch: {
    dateRange(val) {
      this.$emit('updateDateRange', val);
    },
  },
  components: {
    DateTimePicker,
  },
  props: {
    role: String,
    couponOverview: Object,
    loading: Boolean,
    isPremium: Boolean,
  },
  data: () => ({
    dateRange: null,
    couponOverviewShortcuts: [
      {
        text: '今日',
        onClick() {
          return [now, now];
        },
      },
      {
        text: '昨日',
        onClick() {
          return [addDays(now, -1), addDays(now, -1)];
        },
      },
      {
        text: '7日前',
        onClick() {
          return [addDays(now, -7), now];
        },
      },
      {
        text: '30日前',
        onClick() {
          return [addDays(now, -30), now];
        },
      },
      {
        text: '90日前',
        onClick() {
          return [addDays(now, -90), now];
        },
      },
      {
        text: '180日前',
        onClick() {
          return [addDays(now, -180), now];
        },
      },
      {
        text: '本月',
        onClick() {
          return [getMonthStartDate(), getMonthEndDate()];
        },
      },
      {
        text: '上年度',
        onClick() {
          return [new Date(`${nowYear - 1}-01-01`), new Date(`${nowYear - 1}-12-31`)];
        },
      },
    ],
  }),
};
</script>

<style scoped lang="scss">
.coupon-overview-wrapper {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #dde1e5;
  padding-top: 20px;
  width: 100%;
  display:inline-block;
  color: #fff;
  position: relative;

  @media (max-width: 1200px) {
    height: auto;
  }

  .listing-title {
    font-weight: 500;
    color: #174169;
    font-size: 18px;
    box-sizing: border-box;
    padding: 0px 20px;
    display: inline-block;
    height: 40px;
    width:100%;
    border-bottom: 1px solid #EBEEF0;
    display: flex;
    justify-content: space-between;

    @media (max-width: 1200px) {
      padding: 0px 15px;
      font-size: 16px;
    }

    .custom-datepicker {
      @media (max-width: 1200px) {
        font-size: 15px;
        margin-right: 0px;
      }
    }
  }

  .overview-wrapper{
    width: 100%;
    display: flex;
    justify-content: space-between;

    .overview{
      width: 100%;
      color: #000;
      display: flex;
      justify-content: space-between;
      padding: 13px 13px;
      box-sizing: border-box;

      .left {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-content: space-between;

        .quantity {
          font-size: 32px;
          color: #174169;

          @media (max-width: 1200px) {
            font-size: 24px;
          }
        }
        .title {
          color: #696969;
          font-size: 14px;

          @media (max-width: 1200px) {
            font-size: 12px;
          }
        }
      }
      .right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: right;
        padding-right: 35px;
        border-right: 1px solid #ccc;

        @media (max-width: 1200px) {
          display: none;
        }

        img {
          width: 60px;
          height: 60px;

          @media (max-width: 1200px) {
            display: none;
          }
        }
      }
    }

    .overview:last-child {
      .right {
        border: 0px;
      }
    }
  }
}

.loading {
  opacity: 0.5;
}

.normal {
  height: 288px;
  // reduce width to adapt advertisement component
  width: 60%;
  @media (max-width: 1200px) {
    width: 100%;
  }

  .overview-wrapper {
    padding-top: 5%;
  }
}

.vl {
  border-left: 1px solid #979797;
  border-radius: 10px;
  height: 40px;
  margin-top: 20px;
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
}
</style>
